module.exports = __webpack_public_path__ + "static/media/consulting.4e4fa422.svg";